import { useContext, useEffect } from "react";

import { MktgDataContext } from "@swa-ui/application";
import { useLocation } from "@swa-ui/browser";

import { getProductString, getSeatProducts, getTargetSeatString } from "./airSeatsHelperUtils";
import { AIR_SEATS_ROUTES } from "./defines/airSeatRoutes";

export function useConfirmationSeatsAnalytics(seatConfirmationDetails, rrChaseCardType) {
  const { pathname } = useLocation();
  const {
    confirmationNumber,
    fareBreakdownDetails,
    passengerSeatDetails,
    paymentDetails,
    totalCredit,
    totalFare,
    tripType,
  } = seatConfirmationDetails;
  const { setMktgPageData } = useContext(MktgDataContext);
  const tripDetails = passengerSeatDetails[0]?.tripDetails;
  const airportCodes = passengerSeatDetails?.[0]?.tripDetails?.map(
    (tripDetail) => `${tripDetail.departureStation}:${tripDetail.arrivalStation}`
  );

  const getSeatFunds = (fundType) => {
    const totalSeatFund = {
      debit: 0,
      credit: 0,
    };

    fareBreakdownDetails.forEach((fareBreakdownDetail) => {
      fareBreakdownDetail.seatTransactions.forEach((seatTransaction) => {
        if (seatTransaction.transactionType === fundType) {
          totalSeatFund[fundType] += seatTransaction.amount || 0;
        }
      });
    });

    return totalSeatFund[fundType];
  };

  const getSeatSelectionSkippedCount = () => {
    let totalSkippedCount = 0;

    passengerSeatDetails.forEach((passengerSeatDetail) => {
      passengerSeatDetail.tripDetails.forEach((tripDetail) => {
        if (tripDetail.seatSelectionSkipped) {
          totalSkippedCount += 1;
        }
      });
    });

    return `${totalSkippedCount}`;
  };

  useEffect(() => {
    if (pathname === AIR_SEATS_ROUTES.confirmation) {
      setMktgPageData(
        {
          air_confirmationnumber: confirmationNumber,
          airportCodes: airportCodes.toString(),
          bound_seat: getTargetSeatString(passengerSeatDetails),
          changetype: totalFare > totalCredit ? "cost" : "even",
          number_passengers: `${passengerSeatDetails?.length}`,
          rrchasecardtype: rrChaseCardType ?? "",
          segments: `${tripDetails?.length}`,
          seatprice: `${getSeatFunds("debit")}`,
          seatcredit: `${getSeatFunds("credit")}`,
          seatselectionskip_count: `${getSeatSelectionSkippedCount()}`,
          revenuestream: "seats",
          seatsstandalone: "1",
          purchase: "1",
          formofpayment:
            paymentDetails?.map((paymentDetail) => paymentDetail.paymentMethod).join(",") || "",
          seatproduct: getProductString(getSeatProducts(seatConfirmationDetails, tripType, true)),
          productarray: getSeatProducts(seatConfirmationDetails, tripType, true),
        },
        "confirmSeats"
      );
    }
  }, [seatConfirmationDetails, rrChaseCardType]);
}
